/**
 * Component: Customers header
 * -----------------------------------------------------------------------------
 * Controls customers header navigation toggle functionality.
 *
 */
import classes from '~/config/classes'

/**
 * DOM selectors.
 */
const selectors = {
  navigation: '[js-customers-header="navigation"]',
  toggle: '[js-customers-header="toggle"]',
  icon: '.button__icon',
  link: '[js-customer-header="link"]',
}

/**
 * Export customers navigation.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    navigation: document.querySelector(selectors.navigation),
    toggle: document.querySelector(selectors.toggle),
    link: [...document.querySelectorAll(selectors.link)],
  }

  /**
   * Initialise component.
   */
  function init() {
    setEventListeners()
    scrollToLink()
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    if (!nodeSelectors.toggle) {
      return
    }

    nodeSelectors.toggle.addEventListener('click', () => toggleNavigation())
  }

  /**
   * Scroll navigation to the active nav item.
   */
  function scrollToLink() {
    nodeSelectors.link.forEach((link) => {
      if (link.classList.contains(classes.active)) {
        link.scrollIntoView
        ({ behavior: 'smooth', block: 'nearest', inline: 'center' })
      }
    })
  }

  /**
   * Toggle display of navigation.
   */
  function toggleNavigation() {
    nodeSelectors.navigation.classList.toggle(classes.active)
    const icon = nodeSelectors.toggle.querySelector(selectors.icon)

    if (nodeSelectors.navigation.classList.contains(classes.active)) {
      icon.innerHTML = cnvs.icons.misc.minus
      nodeSelectors.toggle.setAttribute('aria-expanded', true)
      return
    }

    icon.innerHTML = cnvs.icons.misc.plus
    nodeSelectors.toggle.setAttribute('aria-expanded', false)
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
